module.exports = __webpack_public_path__ + "media/images/mobile/solutions/solution-main-9c4fedd794201018dea317d661b5c412.png";